// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { LocationProductForOrderResponse } from './location-product-for-order-response';

// @ts-ignore
import { LocationProductItemForOrderResponse } from './location-product-item-for-order-response';

// @ts-ignore
import { OrderProductOptionResponse } from './order-product-option-response';

/** See com.rev360.pms.api.controller.order.EyeglassLensOrderDetailResponse */
/* istanbul ignore next */
@GandalfModel
export class EyeglassLensOrderDetailResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	bifocalSize!: string | null;

	@GandalfProperty({ designType: LocationProductForOrderResponse })
	locationProduct!: LocationProductForOrderResponse | null;

	@GandalfProperty({ designType: LocationProductItemForOrderResponse })
	locationProductItem!: LocationProductItemForOrderResponse | null;

	@GandalfProperty({ designType: OrderProductOptionResponse })
	pal!: OrderProductOptionResponse | null;

	@GandalfProperty({ designType: Boolean })
	singleVision!: boolean | null;

	@GandalfProperty({ designType: String })
	trifocalSize!: string | null;

}
